// These are deal lists which we don't want to double post with the main deals database
// export const notPostingDealLists = [
//   'Toys',
//   'Office / School',
//   'Personal Care',
//   'Cricut',
//   'Most Loved Beauty Deals',
//   'Soda and cocktail mixers',
//   'Organic',
//   'Fruit juice',
//   'Diapers',
//   'Fruit Juice',
//   'Boardgames',
//   'Books for Kids'
// ];

// These are brands which are from the toy deals that we don't want to double post with the main deals database
// export const bannedBrands = ['Amazon', 'Barbie', 'NATIONAL GEOGRAPHIC', 'LEGO'];

// do not omit these fields when editing a page deal
export const comboFieldTypes = [
  'TOY_DEAL_BRAND',
  'TOY_DEAL_CATEGORY_KEYWORD',
  'TOY_DEAL_SECOND_CATEGORY',
  'TOY_DEAL_KEYWORD',
  'BRAND',
  'CATEGORY',
  'TOP_CHEAP_CATEGORY_DEALS_UNDER_3',
  'DEAL_LIST',
  'GIFT_GUIDE'
];

export const bannedCategories = [
  'Toys & Games',
  'Books',
  'Grocery',
  'Baby',
  'Automotive Parts and Accessories',
  'Personal Computer'
];

export const pageDealTypes = [
  {
    name: 'Deal List',
    value: 'DEAL_LIST'
  },
  {
    name: 'Category',
    value: 'CATEGORY'
  },
  {
    name: 'Top cheap category deals under $3',
    value: 'TOP_CHEAP_CATEGORY_DEALS_UNDER_3'
  },
  {
    name: 'Gift Guide',
    value: 'GIFT_GUIDE'
  },
  {
    name: 'Deals that beat inflation',
    value: 'INFLATION_BEATING'
  },
  {
    name: 'Most Popular Amazon Deals for Parents',
    value: 'MOST_POPULAR_DEALS_FOR_PARENTS'
  },
  {
    name: 'Black Friday',
    value: 'BLACK_FRIDAY'
  },
  {
    name: 'Black Friday Subscribe & Save',
    value: 'BLACK_FRIDAY_SS'
  },
  {
    name: 'Final Hours',
    value: 'FINAL_HOURS'
  },
  {
    name: 'Subscribe & Save',
    value: 'SUBSCRIBE_SAVE'
  },
  {
    name: 'Brand deals',
    value: 'BRAND'
  },
  {
    name: 'Under $1',
    value: 'UNDER_ONE'
  },
  {
    name: 'Under $3 Subscribe Save',
    value: 'UNDER_THREE_SUBSCRIBE_SAVE'
  },
  {
    name: 'Gifts for Everyone Under $10',
    value: 'GIFTS_UNDER_TEN'
  },
  {
    name: 'Subscribe Save Coupons',
    value: 'SUBSCRIBE_SAVE_COUPONS'
  },
  {
    name: 'Amazon Prime Day Deals',
    value: 'PRIME_DAY_DEALS'
  },
  {
    name: 'Amazon Labor Day Weekend Deals',
    value: 'LABOR_DAY_DEALS'
  },
  {
    name: 'Only promotions',
    value: 'ONLY_PROMOTIONS'
  },
  {
    name: 'Coupon deals',
    value: 'COUPON_DEALS'
  },
  {
    name: 'Top Deals',
    value: 'TOP_DEALS'
  },
  {
    name: 'Top Deals 2023',
    value: 'TOP_DEALS_2023'
  },
  {
    name: 'Top Deals 2024',
    value: 'TOP_DEALS_2024'
  },
  {
    name: '50% off deals',
    value: 'FIFTY_OFF'
  },
  {
    name: 'All Toy Deals',
    value: 'ALL_TOYS'
  },
  {
    name: 'Toy Deal Keyword',
    value: 'TOY_DEAL_KEYWORD'
  },
  {
    name: 'Toy Deal Category Keyword',
    value: 'TOY_DEAL_CATEGORY_KEYWORD'
  },
  {
    name: 'Toy Deal Second Category',
    value: 'TOY_DEAL_SECOND_CATEGORY'
  },
  {
    name: 'Toy Deal Brand Keyword',
    value: 'TOY_DEAL_BRAND'
  },
  {
    name: 'Promo Fixed Deals',
    value: 'PROMO_FIXED'
  },
  {
    name: 'Diaper Deals',
    value: 'DIAPERS'
  }
];

export const sanitizeSlug = (slug: string): string => {
  let newSlug = `Amazon Deals ${slug}`.replace(/\s+/g, '-').toLowerCase();
  newSlug = newSlug.replace(/\s+/g, '-').toLowerCase();
  // remove punctuation that isn't a dash
  newSlug = newSlug.replace(/[^\w\s-]/g, '');

  // do not need double
  newSlug = newSlug.replace('amazon-deals-amazon-deals', 'amazon-deals');

  return newSlug;
};

export const supportedTimeFrames = [
  {
    name: 'All',
    value: 'ALL'
  },
  {
    name: 'Halloween',
    value: 'HALLOWEEN'
  },
  {
    name: 'Christmas',
    value: 'CHRISTMAS'
  },
  {
    name: 'Prime Day',
    value: 'PRIME_DAY'
  },
  {
    name: 'Black Friday',
    value: 'BLACK_FRIDAY'
  },
  {
    name: 'Cyber Monday',
    value: 'CYBER_MONDAY'
  },
  {
    name: 'Easter',
    value: 'EASTER'
  },
  {
    name: 'Back to school',
    value: 'BACK_TO_SCHOOL'
  }
];
